import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Get all banners (admin endpoint)
export const getAllBanners = createAsyncThunk(
  "banners/getAllBanners",
  async () => {
    const response = await api.get("/admin-banners");
    console.log("respone", response.data)

    // Transform the response to match table expectations
    return response.data || [];
  }
);

export const addSingleBanner = createAsyncThunk(
  'banner/addSingle',
  async ({ bannerData }) => {
    const response = await api.post(`/admin-banners/`, bannerData);
    return response.data;
  }
);


export const updateSingleBanner = createAsyncThunk(
  'banner/updateSingle',
  async ({ bannerId, bannerData }) => {
    const response = await api.put(`/admin-banners/${bannerId}`, bannerData);
    return response.data;
  }
);

export const deleteSingleBanner = createAsyncThunk(
  'banner/deleteSingleBanner',
  async ({ bannerId }) => {
    const response = await api.delete(`/admin-banners/${bannerId}`);
    return response.data;
  }
);

// Upsert banners (update all banners at once)
export const upsertBanners = createAsyncThunk(
  "banners/upsertBanners",
  async ({ token, banners }, { rejectWithValue }) => {
    try {
      // Validate banners array
      if (!Array.isArray(banners) || banners.length < 2 || banners.length > 5) {
        throw new Error("Provide between 2 and 5 banners");
      }

      // Transform banners to match backend expectations
      const transformedBanners = banners.map((banner, index) => ({
        imageUrl: banner.bannerImage,
        linkUrl: banner.linkUrl || null,
        order: banner.order || index + 1,
        isVisible: banner.isVisible !== undefined ? banner.isVisible : true,
      }));

      const response = await api.put(
        "/admin-banners",
        { banners: transformedBanners },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return {
        success: true,
        response: response.data,
      };
    } catch (error) {
      return rejectWithValue({
        success: false,
        error: {
          message: error.response?.data?.message || error.message || "Failed to update banners",
          status: error.response?.status,
        },
      });
    }
  }
);
